import React, { memo } from "react";
import { styled } from "@mui/material";
import logo from "../assets/logo.webp";

const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1, 0),
  position: "sticky",
  top: 0,
  zIndex: 999,
  background: "transparent",

  // Prevent text selection and force default cursor
  userSelect: "none",
  WebkitUserSelect: "none",
  msUserSelect: "none",
  MozUserSelect: "none",
  cursor: "default",
}));

const LogoContainer = styled("div")(({ theme }) => ({
  marginRight: theme.spacing(1),
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  // Ensure image doesn't trigger "drag" ghosting
  pointerEvents: "none",
}));

const LogoImage = styled("img")(({ theme }) => ({
  height: "50px",
  width: "50px",
  objectFit: "contain",
  [theme.breakpoints.down("sm")]: {
    height: "42px",
    width: "42px",
  },
}));

const Title = styled("h1")(({ theme }) => ({
  fontFamily: '"Proxima Nova", "Inter", "Source Sans Pro", sans-serif',
  fontWeight: 800,
  fontSize: "2.4rem",
  lineHeight: 1,
  margin: 0,
  padding: 0,
  letterSpacing: "-1.5px",
  background: "#1d1d1f",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  display: "inline-block",
  filter: "none",

  [theme.breakpoints.down("sm")]: {
    fontSize: "1.9rem",
    letterSpacing: "-1px",
  },
}));

const LogoHeader = memo(({}) => {
  return (
    <HeaderWrapper>
      <LogoContainer>
        <LogoImage
          src={logo}
          alt="Logo"
          fetchpriority="high"
          draggable="false" // Prevents the user from dragging the image
        />
      </LogoContainer>
      <Title>thelinkup</Title>
    </HeaderWrapper>
  );
});

export default LogoHeader;
